import { render, staticRenderFns } from "./AddTransfer.vue?vue&type=template&id=65eeb6bc&scoped=true"
import script from "./AddTransfer.vue?vue&type=script&lang=js"
export * from "./AddTransfer.vue?vue&type=script&lang=js"
import style0 from "./AddTransfer.vue?vue&type=style&index=0&id=65eeb6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eeb6bc",
  null
  
)

export default component.exports